<div
  class="bg-white mt-3 px-5 border h-11 rounded-lg flex items-center justify-between w-full"
  [ngClass]="{
    'shadow-sm border-navy-50': value,
    'hover:border-navy-90': value && editable,
    'border-navy-40 hover:border-navy-50': !value || comingSoon,
    'cursor-pointer': !comingSoon && editable,
    'pointer-events-none': comingSoon || !editable
  }"
>
  @if (title || subtitle || iconSrc) {
    <div class="h-5 flex items-center" [ngClass]="{ 'filter opacity-50': !value }">
      @if (iconSrc) {
        <svg-icon
          class="icon h-5 w-5 mr-2.5 pointer-events-auto"
          [src]="iconSrc"
          [ngbTooltip]="shouldDisplayTooltip && tooltipText ? tooltip : null"
          [placement]="'top'"
        ></svg-icon>
      }

      <span class="font-secondary h-6 pt-0.5 font-bold inline-block align-middle text-base">{{ title }}</span>

      @if (value && subtitle) {
        <span class="h-6 font-light text-navy-70 pt-0.5 ml-2 pl-2 border-l border-navy-70 inline-block align-top text-base">
          {{ subtitle }}
        </span>
      }
    </div>
  }

  @if (editable) {
    <div class="py-1.5 h-6 flex items-center">
      @if (comingSoon) {
        <svg-icon class="coming-soon-icon" preserveAspectRatio="none" [src]="'coming-soon'" [stretch]="true"></svg-icon>
      } @else {
        <app-toggle [formControl]="toggleControl"></app-toggle>
      }
    </div>
  }
</div>

<ng-template #comingSoonIcon>

</ng-template>

<ng-template #tooltip>
  <span class="max-w-60">{{tooltipText}}</span>
</ng-template>
